type SelectOption = {
    value: string;
    label: string;
};

const enum CallEndReason {
    ExpiredLink,
    NoParticipants,
    Default,
}

const enum VidyoSdkCallEndReason {
    Booted = 'VIDYO_CONNECTORDISCONNECTREASON_Booted',
    InvalidResourceId = 'VIDYO_CONNECTORFAILREASON_InvalidResourceId',
}

export type {SelectOption};

export {CallEndReason, VidyoSdkCallEndReason};
